//region :: Imports ::
import MComponent from '../../Toolkit/Components/Component';
import {evalulateBool, MBoolean} from '../../Toolkit/Components/Controls/Control';
import {ReactElement, ChangeEvent, HTMLInputTypeAttribute, RefObject, createRef} from 'react';
import {InputTextarea} from 'primereact/inputtextarea';
import {FieldProps} from 'formik';
import {MNullable, setFieldValue} from '../../Toolkit/Utils';
import {findDOMNode} from 'react-dom';

//endregion

/** */
export type MInputAreaValueType = string | number | readonly string[];

/** */
type Props = {
    id: string;
    initialValue?: MInputAreaValueType;
    type?: HTMLInputTypeAttribute;
    maxLength: number;
    placeholderText?: string;
    readonly?: boolean;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    autoResize?: boolean;
    cols?: number;
    rows?: number;
    onChange?: (newValue: MInputAreaValueType) => void;
}

/** */
type State = {
    value: MInputAreaValueType;
}

/** */
class MTextArea extends MComponent<Props, State> {

    private readonly m_inputRef: RefObject<any>;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.m_inputRef = createRef<any>();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.setFocus = this.setFocus.bind(this);
        this.input_onChange = this.input_onChange.bind(this);

    }

    /** */
    private initializeState(): void {

        this.state = {value: this.props.initialValue === undefined ? '' : this.props.initialValue};
        setFieldValue(this.props.fieldProps, this.state.value);

    }

    /** */
    private input_onChange(event: ChangeEvent<HTMLTextAreaElement>): void {
        this.setValue(event.target.value);
    }

    /** */
    public setFocus(): void {

        setTimeout(() => {

            const element = findDOMNode(this.m_inputRef.current!) as MNullable<HTMLInputElement>;
            element?.focus();

        }, 200);

    }

    /** */
    public setValue(newValue: MInputAreaValueType): void {

        this.safeSetState((draft: State) => draft.value = newValue);
        setFieldValue(this.props.fieldProps, newValue);
        this.props.onChange?.(newValue);

    }

    /** */
    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {

        if(this.props.fieldProps?.field.value !== prevProps.fieldProps?.field.value) {

            this.safeSetState((draft: State) =>
                draft.value = this.props.fieldProps!.field.value);

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <InputTextarea id={this.props.id}
                           maxLength={this.props.maxLength}
                           placeholder={this.props.placeholderText}
                           readOnly={this.props.readonly ?? false}
                           disabled={evalulateBool(this.props.disabled)}
                           className={this.props.className}
                           {
                               ...this.props.fieldProps?.field
                           }
                           autoResize={this.props.autoResize ?? false}
                           cols={this.props.cols ?? 30}
                           rows={this.props.rows ?? 1}
                           value={this.state.value}
                           onChange={this.input_onChange}
                           ref={this.m_inputRef}/>
        );

    }

}

export default MTextArea;
